/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageAllInspectionsComponentResponse
 */
export interface UndercarriageAllInspectionsComponentResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsComponentResponse
     */
    component?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsComponentResponse
     */
    side?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsComponentResponse
     */
    wearMm?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsComponentResponse
     */
    wearPercent?: number | null;
}

/**
 * Check if a given object implements the UndercarriageAllInspectionsComponentResponse interface.
 */
export function instanceOfUndercarriageAllInspectionsComponentResponse(value: object): value is UndercarriageAllInspectionsComponentResponse {
    return true;
}

export function UndercarriageAllInspectionsComponentResponseFromJSON(json: any): UndercarriageAllInspectionsComponentResponse {
    return UndercarriageAllInspectionsComponentResponseFromJSONTyped(json, false);
}

export function UndercarriageAllInspectionsComponentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageAllInspectionsComponentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'component': json['component'] == null ? undefined : json['component'],
        'side': json['side'] == null ? undefined : json['side'],
        'wearMm': json['wearMm'] == null ? undefined : json['wearMm'],
        'wearPercent': json['wearPercent'] == null ? undefined : json['wearPercent'],
    };
}

export function UndercarriageAllInspectionsComponentResponseToJSON(json: any): UndercarriageAllInspectionsComponentResponse {
    return UndercarriageAllInspectionsComponentResponseToJSONTyped(json, false);
}

export function UndercarriageAllInspectionsComponentResponseToJSONTyped(value?: UndercarriageAllInspectionsComponentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'component': value['component'],
        'side': value['side'],
        'wearMm': value['wearMm'],
        'wearPercent': value['wearPercent'],
    };
}

